import * as Twilio from 'twilio-sync'
import { TwilioBridgeDataDocInterface, TwilioUIDocValueInterface, TwilioUIDocInterface, TwilioBookingDocInterface, TwilioBookingDocValueInterface } from './types'
import { mediaType as MediaType, status as Status } from '@bt-react/constants'
import { LayoutType } from '../../slices/layouts/layoutsSlice'

export interface DocsReducerInterface {
  bookingDoc: TwilioBookingDocInterface | null
  bridgeDataDoc: TwilioBridgeDataDocInterface | null
  syncClient: Twilio.SyncClient | null
  uiDoc: TwilioUIDocInterface | null
  questionsDoc: Twilio.SyncClient | null
  seatingOrderMap: Twilio.SyncMap | null
}

export const twilioUIDataDefaultState: TwilioUIDocValueInterface = {
  endingLive: false,
  focusOn: null,
  screenShareFocus: null,
  gigTerminationTime: '',
  goingLive: false,
  mute: [],
  playInMute: [],
  liveDateTime: null,
  liveEnded: false,
  mediaType: MediaType.WEBCAM,
  participantInformation: [],
  presenterCount: 0,
  videoDisplay: [],
  pendingSlidesId: null,
  slidePosition: {
    selectedSlideStep: 0,
    selectedSlide: 0
  },
  autoSpotlight: false,
  dominantSpeaker: null,
  eventStreamUrl: '',
  layouts: {
    presenterLayout: {
      presenterLayoutsActive: false,
      sidebarActive: false,
      layoutType: LayoutType.Full,
    },
    mediaLayout: {
      mediaSidebarActive: false,
      mediaLayoutType: LayoutType.Full
    }
  },
  conversationCreatorId: '',
  conversationName: '',
  questions: {
    c: '',
    s: false,
    a: false
  }
}

export const twilioBookingDataDefaultState: TwilioBookingDocValueInterface = {
  status: Status.UPCOMING
}

const defaultState: DocsReducerInterface = {
  bookingDoc: null,
  bridgeDataDoc: null,
  syncClient: null,
  uiDoc: null,
  questionsDoc: null,
  seatingOrderMap: null
}

export default defaultState
